import { useDispatch, useSelector } from "react-redux";
import { fieldsToCheckMortgage } from "../../../data/permitFormsData";
import FinancialBPModal from "../FinancialBPModal";
import React from "react";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";

const AddingNewMortgageModal = () => {
  const { addingNewMortgage } = useSelector((state) => state.buildingState);

  const dispatch = useDispatch();

  return (
    <FinancialBPModal
      type="mortgage"
      open={addingNewMortgage}
      title={"Add New Mortgage Lender"}
      handleStateNo={() => {
        dispatch(setBuildingState({ addingNewMortgage: false }));
      }}
      fieldsToCheck={fieldsToCheckMortgage}
    />
  );
};

export default React.memo(AddingNewMortgageModal);
